/*
  Free gift auto-add.
  Keeps exactly one colour-matched gift line in the cart for each parent product
  that declares one, and removes gift lines whose parent has left the cart.
  Pairs come from the product metafield custom.free_gift, rendered by
  snippets/free-gift-auto.liquid. If no pairs are rendered this file does nothing.
*/
(function () {
  'use strict';

  var CONFIG_EL = 'free-gift-map';
  var GIFT_FLAG = '_free_gift';
  var pairs = null;      // parentVariantId -> giftVariantId
  var giftIds = null;    // Set of gift variant ids
  var busy = false;
  var again = false;

  function readConfig() {
    var el = document.getElementById(CONFIG_EL);
    if (!el) return false;
    try {
      var raw = JSON.parse(el.textContent || '[]');
      pairs = {};
      giftIds = {};
      for (var i = 0; i < raw.length; i++) {
        var p = raw[i];
        if (!p || !p.parent || !p.gift) continue;
        pairs[String(p.parent)] = String(p.gift);
        giftIds[String(p.gift)] = true;
      }
      return Object.keys(pairs).length > 0;
    } catch (e) {
      return false;
    }
  }

  function getCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /* What the cart should contain, given the parent items in it. */
  function plan(cart) {
    if (!cart || !cart.items) return null;

    var wanted = {};   // giftVariantId -> qty
    var present = {};  // giftVariantId -> {qty, key}

    cart.items.forEach(function (item) {
      var id = String(item.variant_id);
      var isGift = giftIds[id] && item.properties && item.properties[GIFT_FLAG];
      if (isGift) {
        present[id] = { qty: item.quantity, key: item.key };
        return;
      }
      var gift = pairs[id];
      if (gift) wanted[gift] = (wanted[gift] || 0) + item.quantity;
    });

    var adds = [];
    var updates = {};

    Object.keys(wanted).forEach(function (gid) {
      var have = present[gid] ? present[gid].qty : 0;
      if (have === 0) adds.push({ id: Number(gid), quantity: wanted[gid] });
      else if (have !== wanted[gid]) updates[present[gid].key] = wanted[gid];
    });

    /* Orphaned gifts: parent gone, or quantity no longer justified. */
    Object.keys(present).forEach(function (gid) {
      if (!wanted[gid]) updates[present[gid].key] = 0;
    });

    if (!adds.length && !Object.keys(updates).length) return null;
    return { adds: adds, updates: updates };
  }

  function root() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function applyPlan(p) {
    var chain = Promise.resolve();

    if (p.adds.length) {
      var items = p.adds.map(function (a) {
        var props = {};
        props[GIFT_FLAG] = 'true';
        return { id: a.id, quantity: a.quantity, properties: props };
      });
      chain = chain.then(function () {
        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        });
      });
    }

    if (Object.keys(p.updates).length) {
      chain = chain.then(function () {
        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: p.updates })
        });
      });
    }

    return chain;
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return Promise.resolve();
    var sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    return fetch(root() + '?sections=' + encodeURIComponent(sections), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sectionsJson) {
        if (!sectionsJson) return;
        return getCart().then(function (cart) {
          if (!cart) return;
          cart.sections = sectionsJson;
          if (typeof drawer.renderContents === 'function') drawer.renderContents(cart);
        });
      })
      .catch(function () {});
  }

  function reconcile() {
    if (!pairs) return;
    if (busy) { again = true; return; }
    busy = true;

    getCart()
      .then(function (cart) {
        var p = plan(cart);
        if (!p) return null;
        return applyPlan(p).then(refreshDrawer);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; setTimeout(reconcile, 60); }
      });
  }

  /* Watch for cart mutations made by the theme, then reconcile. */
  function isCartMutation(url) {
    if (!url) return false;
    var u = String(url);
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u);
  }

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var isOurs = url && /cart\/(add|update)\.js/.test(String(url)) && busy;
      var out = nativeFetch.apply(this, arguments);
      if (isCartMutation(url) && !isOurs) out.then(function () { reconcile(); }, function () {});
      return out;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) {
      this.addEventListener('load', function () { if (!busy) reconcile(); });
    }
    return nativeOpen.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (readConfig()) reconcile();
  });
  if (document.readyState !== 'loading') {
    if (readConfig()) reconcile();
  }
})();
